// src/components/ui/ShareButton.tsx
import React, { useState } from 'react';

interface Props {
  onShare: () => Promise<{ shareId: string; url: string } | null>;
}

export function ShareButton({ onShare }: Props) {
  const [state, setState] = useState<'idle' | 'loading' | 'copied'>('idle');

  const handleClick = async () => {
    setState('loading');
    try {
      const result = await onShare();
      if (result?.url) {
        await navigator.clipboard.writeText(result.url);
        setState('copied');
        setTimeout(() => setState('idle'), 2500);
      } else {
        setState('idle');
      }
    } catch {
      setState('idle');
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={state === 'loading'}
      title="Share this answer"
      className="text-xs text-gray-400 hover:text-gray-600 transition-colors disabled:opacity-50 flex items-center gap-1"
    >
      {state === 'loading' && <span className="animate-spin">↻</span>}
      {state === 'copied' && <span className="text-green-600">✓ Link copied!</span>}
      {state === 'idle' && <span>🔗 Share</span>}
    </button>
  );
}
